import React from 'react'
import  banner from '../../Assets/BANNER 2.png'

const Banner = () => {
  return (
    <div className=" max-w-screen-2xl mx-auto">
    
      </div>
  )
}

export default Banner